import styled from 'styled-components/macro';
import { ModalV2 } from 'Ui/ModalV2';
import qrCodePath from 'Assets/images/QR_BZC_app_print_HD.png';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

const Body = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
`;

const Title = styled.h2`
  font-family: var(--font-primary);
  font-size: 1.8rem;
  font-weight: 600;
  color: #000;
  margin: 0 0 2rem;
  text-align: center;
`;

const QrCodeImage = styled.img`
  width: 20rem;
  height: 20rem;
`;

export const QrCodeModal = ({ isOpen, onClose }: Props) => {
  return (
    <ModalV2
      isOpen={isOpen}
      onClose={onClose}
      size="small"
      closeIconPosition={1.5}
    >
      <Body>
        <Title>Scannez pour télécharger l'application</Title>
        <QrCodeImage src={qrCodePath} alt="QR code de téléchargement de l'application" />
      </Body>
    </ModalV2>
  );
};

export default QrCodeModal;
